@reference "@glow/tailwind-config/reference.css";

.form-select {
  @apply relative;
}

.show-in-form {
  @apply relative;
  @apply mt-5;
}
.show-in-form .labelText {
  @apply absolute;
  @apply top-[-18px];
}

.searchable {
  @apply m-4;
}
.searchable input {
  @apply bg-gray-100;
  @apply border-none;
}

.labelText {
  @apply text-emphasis-extra;
  @apply text-xs;
  @apply text-gray-500;
  @apply whitespace-nowrap;
}
.labelText.focus {
  @apply text-emphasis-extra;
}

button.hasError,
div[role="combobox"].hasError {
  @apply border-red-700;
}
.error-text {
  @apply text-red-700;
  @apply italic;
}
.error {
  @apply text-red-700;
  @apply mt-1;
}

.dropdown-button {
  @apply cursor-pointer;
  @apply bg-white;
  @apply border-gray-300;
  @apply border-solid;
  @apply border;
  @apply flex;
  @apply justify-between;
  @apply items-center;
  @apply w-full;
  @apply rounded-sm;
  @apply p-3;
  font-size: max(var(--text-sm), 1em);
  @apply whitespace-nowrap;
  @apply h-10;
}

.position-above {
  bottom: calc(44px + 0.25em);
}

.dropdown-button:disabled {
  @apply opacity-30;
}

.dropdown-button:focus {
  @apply border-primary-500;
}
.dropdown-button > svg {
  @apply ml-2;
  @apply text-primary-500;
}

.dropdown-list {
  @apply absolute;
  @apply border-gray-300;
  @apply border;
  @apply border-solid;
  @apply m-0;
  @apply p-0;
  @apply bg-white;
  @apply rounded-sm;
  font-size: max(var(--text-sm), 1em);
  @apply z-500;
  @apply max-h-96;
  @apply overflow-auto;
}

.dropdown-list > li > label {
  @apply px-[1.5em];
  @apply py-[0.75em];
}
.dropdown-list > li:first-of-type {
  @apply mt-3;
}
.dropdown-list > li:last-of-type {
  @apply mb-3;
}
